// @ts-nocheck

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, MenuItem, Select, FormControl } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SoftButton from "../../components/common/softButton";
import { toast } from "react-toastify";
import { deletePublication, getPublication } from "../../features/publication";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import ActionMenu from "../../components/common/custom/action-menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const PublicationManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { publications, status } = useSelector(
    (state: any) => state.publication
  );
  const [language, setLanguage] = useState("en");

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleDelete = (id: string) => {
    // // // console.log(id,'id');

    const isConfirmed = window.confirm(
      "Are you sure you want to delete this publication?"
    );
    if (isConfirmed) {
      dispatch(deletePublication(id))
        .then((res) => {
          toast.success(res.payload.message);
          dispatch(
            getPublication({ page: pageIndex, limit: pageSize, lan: language })
          );
        })
        .catch((err) => {
          console.error(err);
          toast.error("Failed to delete publication.");
        });
    }
  };

  const columns = [
    {
      header: "Photo",
      accessorKey: "photo",
      id: "photo",
      align: "center",
      cell: (info: any) => (
        <img
          src={`${info.getValue()}`}
          alt="Publication Thumbnail"
          style={{ width: "50px", height: "50px", objectFit: "cover" }}
        />
      ),
    },
    {
      header: "Title",
      accessorKey: "title",
      id: "title",
      align: "left",
      cell: (info: any) => <strong>{info.getValue()}</strong>,
    },
    {
      header: "Description",
      accessorKey: "description",
      id: "description",
      align: "left",
      cell: (info: any) => <span>{info.getValue()?.substring(0, 50)}</span>,
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original.slug; // Access the publication id
        return (
          <ActionMenu>
            <MenuItem onClick={() => navigate(`/publication/edit/${id}`)}>
              Edit
            </MenuItem>
            <MenuItem onClick={() => handleDelete(id)}>Delete</MenuItem>
          </ActionMenu>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(
      getPublication({ page: pageIndex, limit: pageSize, lan: language })
    );
  }, [dispatch, pageIndex, pageSize, language]);

  useEffect(() => {
    if (status && publications && publications?.data) {
      setData(publications.data);
      setTotalRows(publications.pagination.total || 0);
    }
  }, [status, publications]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
            >
              <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
                Publication Management
              </SoftTypography>

              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  width: "30%",
                }}
              >
              <FormControl
                sx={{
                  marginRight: "10px",
                  minWidth: "160px",
                }}
                size="small"
              >
                <Select
                  labelId="user-type-label"
                  id="language"
                  name="language"
                  value={language}
                  label="Language"
                  onChange={(e) => setLanguage(e.target.value)}
                  IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
                >
                  <MenuItem value={"en"} sx={{ marginBottom: "5px" }}>
                    English
                  </MenuItem>
                  <MenuItem value={"ar"}>Arabic</MenuItem>
                </Select>
              </FormControl>
              <SoftButton
                onClick={() => navigate("/publication/add")}
                variant="contained"
                color="final"
                style={{textTransform: "Capitalize"}}
              >
                Add Publication
              </SoftButton>
              </SoftBox>
            </SoftBox>
              <Table
                columns={columns}
                data={data}
                pageIndex={pageIndex}
                pageSize={pageSize}
                totalRows={totalRows}
                onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              />
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default PublicationManagement;
